import { RecordingPreference } from '@api/generated/graphql';
import { CallStateDirection } from '../types';
import { serviceState } from '@modules/ServiceModule/workspace';
import { authState } from '@modules/AuthModule/state';

export enum RecordingStatus {
  STARTED = 'STARTED',
  NOT_STARTED = 'NOT_STARTED',
  PAUSED = 'PAUSED',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
}

export type RecordingState = {
  status: RecordingStatus;
  disabled: boolean;
};

export const defaultRecordingState: RecordingState = {
  status: RecordingStatus.NOT_STARTED,
  disabled: true,
};

// in some near future we will add the ALWAYS recording preference
// this should result in a recording state of STARTED and disabled: true

const getInitialRecordingState = (
  direction: CallStateDirection,
  queueIds: string[],
): RecordingState => {
  // outgoing call
  if (direction === 'originating') {
    return {
      status: RecordingStatus.NOT_SUPPORTED,
      disabled: true,
    };
  }

  // incoming - internal calls
  if (queueIds.length === 0) {
    return {
      status: RecordingStatus.NOT_SUPPORTED,
      disabled: true,
    };
  }

  // incoming - external calls
  const queueRecordingPreference = serviceState.queues.find(
    (queue) => queue.id === queueIds[queueIds.length - 1],
  )?.inboundRecording;

  if (queueRecordingPreference === RecordingPreference.Automatic) {
    return {
      status: RecordingStatus.STARTED,
      disabled: false,
    };
  } else if (queueRecordingPreference === RecordingPreference.Never) {
    return {
      status: RecordingStatus.NOT_STARTED,
      disabled: true,
    };
  }

  // queueRecordingPreference is MANUAL or undefined, use userRecordingPreference
  const userRecordingPreference = authState.user?.callRecording;

  if (userRecordingPreference === RecordingPreference.Automatic) {
    return {
      status: RecordingStatus.STARTED,
      disabled: false,
    };
  } else if (userRecordingPreference === RecordingPreference.Manual) {
    return {
      status: RecordingStatus.NOT_STARTED,
      disabled: false,
    };
  } else if (userRecordingPreference === RecordingPreference.Never) {
    return {
      status: RecordingStatus.NOT_STARTED,
      disabled: true,
    };
  }

  return defaultRecordingState;
};

export default getInitialRecordingState;
